import React, { Component } from 'react';
import { CloseOutlined, CloudUploadOutlined, DeleteOutlined, FileFilled, RedoOutlined } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox } from 'antd';
import moment from 'moment';
// import Uploadlayer from '../../../components/FormComponent/Input/upload';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from './../../../services/local-store';
import formDataPostService from '../../../services/httpformData';
import userTrackService from './../../../services/usertrack-service';
import {UPLOAD_URL} from '../../../constants/app-constants';

const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Counselling_upload extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'showDocument': false,
            patientDocument: [],
            body: {},
            tbody: [],
            thead: [{
                "key": 's_no',
                'label': '#'
            }, {
                "key": 'document_description',
                'label': 'Document Description'
            }, {
                "key": 'action',
                'label': 'Upload'
            }, {
                "key": 'submited_files',
                'label': 'Submitted Files'
            }],
            fileList: [],
            disable_15days: false,
            latest_counselling_id: null,
            current_counselling_id: null
        }
    }


    componentDidMount() {
        const { id, slug } = this.props.match.params;
        if(slug !== 'patients-history-details' && slug !== 'pending-docs' && slug!=='pre-auth-worklist'){
        this.initial();
    }
       
        // setTimeout(() => { this.initial() }, 1000)
    }

    componentWillUnmount() {
        this.setState({
            visible: false,

        });
    }
    // componentDidUpdate(prevProps) {

    //     if (this.props.mydata !== prevProps.mydata) {
    //         this.initial()
    //         // this.setState({modal1Visible: true});
    //         console.log("updated selected countries", this.props.mydata);
    //     }
    // }

    initial() {
        this.getMasterDocumentTypes();
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let view = JSON.parse(Storage.get('counselling_view'));
            if (view && view[0]['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist' ) {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
    }

    getMasterDocumentTypes() {
        this.setState({ loadding: true })
        let { getMasterDocumentTypes } = networkList;
        try {
            postService(getMasterDocumentTypes, 'GET', {}).then(res => {
                if (res['status']) {
                    this.setState((state) => ({ 'tbody': res['data'] }));
                    this.setState({ loadding: false })                
                    Storage.store('getMasterDocumentTypes', res['data'])
                } else {
                    this.setState((state) => ({ 'docTypes': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    getPatientDocumentDetails() {
        this.setState({ loadding: true })
        let { getPatientDocumentDetails } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}

        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pending-docs:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
            let disable_15days = null
            if (view && view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
                console.log('disable_15days', disable_15days, days)
            } else {
                disable_15days = false
            }
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": current_counselling_id }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view','current_counselling_id': current_counselling_id })
        }
        try {
            const Userlogobj ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getPatientDocumentDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    this.setState((state) => ({ 'patientDocument': res['data'],'latest_counselling_id': latest_cou_id }));
                    this.setState({ loadding: false })   
                    Storage.store('getPatientDocumentDetails', res['data'])
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    deleteConfirm = (filesArray) => {
        let This = this
        Modal.confirm({
            title: `Do you really want to delete these file?`,
            content: `This process can't be undone.`,
            zIndex: '1022',
            okText: "Delete",
            cancelText: "Cancel",
            onOk: function () {
                window.scrollTo({
                    top: 50,
                    left: 0,
                    behavior: 'smooth'
                });
                This.deleteDocument(filesArray)
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    deleteDocument = (filesArray) => {
        this.setState({ loadding: true })
        let payload = {}
        let { file_uploading_id } = this.state
        console.log('filesArray',filesArray.length, filesArray.length > 1 ?  "remove" : "update" )        
        if (file_uploading_id) {
            payload = { 'file_uploading_id': file_uploading_id.toString(), action_item: filesArray.length >1 ? "remove" : "update"}
            try {
                postService('removePatientDocument', 'POST', { "data": payload }).then(res => {
                    if (res['status']) {
                        Modal.success({
                            title: `Success`,
                            content: `${res['message']}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails()
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res['message']}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }

    }
    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible });
        this.initial()
    }
    handleChange = ({ fileList }) => {
        console.log('filelist', fileList)

        let file = null,
            file_type = null,
            file_name = null,
            file_size = null;
        if (fileList) {
            // fileList.map(async(item, key) =>
            for (let i = 0; i < fileList.length; i++) {
                let item = fileList[i]
                let key = i
                // fileList[key]['status'] = 'done';
                // fileList[key]['base_64'] = await getBase64(file.originFileObj);            
                file = item.originFileObj;
                file_type = item.type;
                file_name = item.name;
                file_size = item.size;
                // check file type
                const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';

                const isLt2M = file_size / 1024 / 1024 < 2;
                if (!isJpgOrPngOrPdf) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }
                // check file size        
                else if (!isLt2M) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the file smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }

                else {
                    // Modal.success({
                    //     title: `success`,
                    //     content: ``,
                    //     zIndex: '1022'
                    // });
                    console.log('check', isJpgOrPngOrPdf, isLt2M)
                    this.submit(file)
                }
            }
            // );
        }


        // fileList.map(async (file, key) => {
        //     fileList[key]['status'] = 'done';
        //     fileList[key]['base_64'] = await getBase64(file.originFileObj);
        // });


        // this.setState((state) => ({ fileList }), () => {
        //     let { value, error,fileList } = this.state;
        //     let { feild_data } = this.props;
        //     feild_data['value'] = fileList;
        //     feild_data['error'] = error;
        //     this.props.inputChange(feild_data)
        // })
    };

    // 
    submit = (file) => {
        this.setState({ loadding: true })
        let user_data = null
        const { id, slug } = this.props.match.params;

        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }
        let { umr_no, ip_no, body } = this.state

        if (file && umr_no && body && body.id && body.document_short_code && user_data['unitid']) {
            var num = body.id;
            var doc_id = num.toString();
            var form_data = new FormData();
            var current_counselling_id = '';
            form_data.append('upfile', file);
            form_data.append("umr", umr_no);
            if (body['document_type'] === 'KYC') {
                form_data.append("ip", null);
            } else {
                form_data.append("ip", ip_no);
            }
            form_data.append("document_short_code", body.document_short_code);
            form_data.append("document_id", doc_id);
            form_data.append("unit_id", user_data['unitid']);

            if (slug === 'patients-history-details') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'pending-docs') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }
            if (slug === 'pre-auth-worklist') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                form_data.append("form_type", 'add');
                form_data.append("counselling_id", '');
            }
            if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                current_counselling_id = this.props.print_counselling_id || '';
                form_data.append("form_type", 'view');
                form_data.append("counselling_id", current_counselling_id);
            }

            // To check for the values are present or not
            // for (var key of form_data.entries()) {
            //     console.log(key[0] + ', ' + key[1]);
            // }
            // console.log('form_data:', form_data);
            try {
                formDataPostService('fileUpload', 'POST', form_data).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        Modal.success({
                            title: `success`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }

    handle2Change = ({ fileList }) => {
        let file = null,
            file_type = null,
            file_name = null,
            file_size = null;
        if (fileList) {
            fileList.map(async (item, key) => {
                file = item.originFileObj;
                file_type = item.type;
                file_name = item.name;
                file_size = item.size;
                // check file type
                const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';
                if (!isJpgOrPngOrPdf) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }
                // check file size        
                const isLt2M = file_size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the file smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }

                if (isJpgOrPngOrPdf && isLt2M) {
                    console.log('check', isJpgOrPngOrPdf, isLt2M)
                    this.resubmit(file)
                }
            });
        }
    };

    resubmit = (file) => {
        this.setState({ loadding: true })
        let user_data = null
        const { id, slug } = this.props.match.params;
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }
        let { umr_no, ip_no, body, file_uploading_id } = this.state
        if (file && umr_no && body && body.id && body.document_short_code && user_data['unitid']) {
            var num = body.id;
            var doc_id = num.toString();

            var current_counselling_id = '';
            var form_data = new FormData();
            form_data.append('upfile', file);
            form_data.append("umr", umr_no);
            if (body['document_type'] === 'KYC') {
                form_data.append("ip", null);
            } else {
                form_data.append("ip", ip_no);
            }
            form_data.append("file_uploading_id", file_uploading_id ? file_uploading_id.toString() : null);
            form_data.append("document_short_code", body.document_short_code);
            form_data.append("document_id", doc_id);
            form_data.append("unit_id", user_data['unitid']);

            if (slug === 'patients-history-details') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'pending-docs') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }
            if (slug === 'pre-auth-worklist') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }


            if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                form_data.append("form_type", 'add');
                form_data.append("counselling_id", '');
            }
            if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                current_counselling_id = this.props.print_counselling_id || '';
                form_data.append("form_type", 'view');
                form_data.append("counselling_id", current_counselling_id);
            }
            // To check for the values are present or not
            // for (var key of form_data.entries()) {
            //     console.log(key[0] + ', ' + key[1]);
            // }

            try {
                formDataPostService('fileUpload', 'POST', form_data).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        Modal.success({
                            title: `success`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }
    onChange(evt, body, item) {
        console.log('checkbox', evt.target.checked)
        if (evt.target.checked) {
            this.checked_true(body);
        } else {
            this.checked_false(item)
        }
    };
    checked_true = (body) => {
        this.setState({ loadding: true })
        let user_data = null
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit is null.`,
                zIndex: '1022'
            });
        }
        let ip = null
        let { umr_no, ip_no, latest_counselling_id } = this.state
        if (umr_no && body && body.id && user_data['unitid']) {
            var num = body.id;
            var id = num.toString();

            if (body['document_type'] === 'KYC') {
                ip = null;
            } else {
                ip = ip_no;
            }
            let payload = {
                "umr": umr_no,
                "ip": ip,
                "document_id": id,
                "unit_id": user_data['unitid'],
                "counselling_id": latest_counselling_id
            }
            console.log('form_data:', body, payload);
            try {
                postService('enableFileUpload', 'POST', { 'data': payload }).then(res => {
                    console.log('enableFileUpload response:', res);
                    if (res.status) {
                        // Modal.success({
                        //     title: `success`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }
    checked_false = (item) => {
        this.setState({ loadding: true })
        let file_uploading_id = item ? item['file_uploading_id'] : true
        if (file_uploading_id) {
            let payload = {
                "file_uploading_id": item ? item['file_uploading_id'].toString() : null,
            }
            console.log('form_data:', item, payload);
            try {
                postService('disableFileUpload', 'POST', { 'data': payload }).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        // Modal.success({
                        //     title: `success`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }

    downloadPatientDocumentsAsPDF() {
        this.setState({ loadding: true })
        let { downloadPatientDocumentsAsPDF } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}

        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": parseInt(counselling_id) }
                }
            } else {
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pending-docs:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": parseInt(counselling_id) }
                    }
            } else {
                
            }
        }
        if (slug === 'pre-auth-worklist') {
            
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pre-auth-worklist:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": parseInt(counselling_id) }
                    }
            } else {
                
            }
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": parseInt(current_counselling_id) }
        }
        try {
            postService(downloadPatientDocumentsAsPDF, 'POST', { "data": payload }).then(res => {
                if (res['status']) {

                    let { base_url } = networkList
                    // fetch(`${base_url}${homepage}${res['single_file_url']}`)
                    fetch(`${UPLOAD_URL}${res['single_file_url']}`)
                        .then(response => {
                            response.blob().then(blob => {
                                let url = window.URL.createObjectURL(blob);
                                let a = document.createElement('a');
                                a.href = url;
                                a.download = res['single_file_url'];
                                a.click();
                            });

                            this.setState({ loadding: false })
                        });
                } else {
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : 'Oops, Something is wrong. Please try again.',
                        zIndex: 1022
                    })
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    render() {
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days, 
            current_counselling_id, latest_counselling_id } = this.state
        // let view = JSON.parse(Storage.get('counselling_view'));
        let pat_doc_ids = []
        patientDocument.map((item, key1) => { pat_doc_ids.push(parseInt(item['document_id'])) })
        const { id, slug } = this.props.match.params
        console.log('curr lat:',this.state.current_counselling_id, this.state.latest_counselling_id)
        return (<React.Fragment>
            {/* <div className="position-sticky" style={{ top: '43px' }}>
                <div className="row mb-2 mx-0"> */}
                    {slug === 'patients-history-details' || slug === 'pending-docs' || slug==='pre-auth-worklist' ? null : <React.Fragment> {showDocument ?
                        <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-ena`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                            {/* this.initial() */}
                            <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                            <p className="mt-2 mb-0">Upload Documents</p>
                        </div>
                        :
                        <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-dis`} style={{ backgroundColor: '#666' }}>
                            <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                            <p className="mt-2 mb-0">Upload Documents</p>
                        </div>
                    }</React.Fragment>}
                    <Modal
                        // title="Upload Documents"
                        centered
                        visible={this.state.modal1Visible}
                        // onOk={() => this.includesOK()}
                        // onCancel={() => this.setModal1Visible(false)}
                        width='95%'
                        height='95%'
                        zIndex={1021}
                        footer={null}
                    >
                        <CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal1Visible(false)} />
                        {ui_form_type === 'view' && disable_15days == true ?
                            <React.Fragment>
                                <h4 className="text-center">Upload Documents</h4>
                                <p className="text-center mb-5 text-danger">This counselling has expired, Uploading documents is not allowed</p>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <h4 className="text-center">Upload Documents</h4>
                                <p className="text-center mb-5">Select the documents required for Cash or Insurance patients</p>
                            </React.Fragment>}                            
                        {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0, zIndex: 9999 }}> <Spin ></Spin></div>}


                        <div className="row pb-3">
                            <div className="col-6 my-auto">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                            </div>
                            <div className="col-2 my-auto">
                                <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                            </div>
                            <div className="col-2 my-auto">
                                <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                            </div>

                            {ui_form_type === 'view' && <div className="col-2 my-auto">
                                <button className="btn btn-success text-capitalize float-right" onClick={() => { this.downloadPatientDocumentsAsPDF() }}>
                                    <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download</span>
                                </button>
                            </div>}
                        </div>
                        <div className="financial-table table-responsive pop-table">
                            <table className="table table-hover table-bordered mb-0 bg-white">
                                <thead style={{ backgroundColor: '#084b69' }}>
                                    <tr className="pop-table">
                                        {thead.map((head, key) => {
                                            if (head['key'] === 's_no') {
                                                return (<td className="text-capitalize align-middle text-center" key={key} >{head['label']}</td>)
                                            }
                                            return (<td className="text-capitalize align-middle" key={key} >{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody.map((body, key) => {
                                        return (<tr key={key} className={`${!pat_doc_ids.includes(body['id']) ? 'tb-blocked' : ''} ${ui_form_type === 'view' && disable_15days ? 'tb-blocked' : ''}`}>
                                            {thead.map((head, Hkey) => {
                                                if (head['key'] === 's_no') {
                                                    return (<td className="text-center">
                                                        {/* {key + 1} */}
                                                        {!pat_doc_ids.includes(body['id']) ? (ui_form_type == 'add') ? <input
                                                            type="checkbox"
                                                            name={key + 1}
                                                            onChange={evt => this.onChange(evt, body)}
                                                            disabled={ui_form_type === 'view' && disable_15days === true ? true : false}
                                                        // disabled={false}
                                                        /> : <input
                                                            type="checkbox"
                                                            name={key + 1}
                                                            onChange={evt => this.onChange(evt, body)}
                                                            disabled={current_counselling_id == latest_counselling_id ? false : true}
                                                        /> : null}
                                                        {patientDocument.map((item, key1) => {
                                                            if ((body['id'] == item['document_id'])) {
                                                                if (item['files'].length > 0 && (item['is_uploaded'] == 1 || item['is_uploaded'] == 0)) {
                                                                    return (<input
                                                                        type="checkbox"
                                                                        name={key + 1}
                                                                        onChange={evt => this.onChange(evt, body, item)}
                                                                        // disabled={false}
                                                                        disabled={ui_form_type === 'view' && (current_counselling_id == latest_counselling_id) ? false : (ui_form_type !== 'view') ? false : true}
                                                                        // && disable_15days === true ? true : false
                                                                        checked={true}
                                                                    />)
                                                                } else {
                                                                    return (<input
                                                                        type="checkbox"
                                                                        name={key + 1}
                                                                        onChange={evt => this.onChange(evt, body, item)}
                                                                        disabled={true}
                                                                    />)
                                                                }
                                                            }
                                                        })
                                                        }
                                                    </td>)
                                                }
                                                if (head['key'] === 'action') {
                                                    let uploadicons_status = null
                                                    if (ui_form_type === 'view' && disable_15days === true) {
                                                        return (<td className="text-center"><Upload disabled={true} action={null} fileList={fileList}>
                                                            <Button icon={<CloudUploadOutlined />} disabled={true}></Button>
                                                        </Upload></td>)
                                                    } else {
                                                        return (<td className="text-center">
                                                            {(body['upload_type'] === 'multiple') &&
                                                                <React.Fragment>
                                                                    {patientDocument.map((item, key1) => {
                                                                        if ((body['id'] == item['document_id'])) {
                                                                            if (item['files'].length > 0 && item['is_uploaded'] == 1) {
                                                                                return (<Upload action={null} fileList={fileList} onChange={this.handleChange} onClick={() => { this.setState({ body: body }) }}  >
                                                                                    {/* maxCount={body['upload_type'] === 'single' ? 1 : 5} multiple={body['upload_type'] === 'single' ? false : true} */}
                                                                                    <Tooltip title="Click here to upload">
                                                                                        <Button icon={<CloudUploadOutlined />}></Button>
                                                                                    </Tooltip>
                                                                                </Upload>)
                                                                            } else if (item['files'].length > 0 && item['is_uploaded'] == 0) {
                                                                                return (<Upload action={null} fileList={fileList} onChange={this.handle2Change} onClick={() => { this.setState({ body: body, file_uploading_id: item['file_uploading_id'] }) }}  >
                                                                                    {/* maxCount={body['upload_type'] === 'single' ? 1 : 5} multiple={body['upload_type'] === 'single' ? false : true} */}
                                                                                    <Tooltip title="Click here to upload">
                                                                                        <Button icon={<CloudUploadOutlined />}></Button>
                                                                                    </Tooltip>
                                                                                </Upload>)
                                                                            } else {
                                                                                return (<p>-</p>)
                                                                            }

                                                                        }
                                                                    })
                                                                    }
                                                                </React.Fragment>

                                                            }
                                                            {(body['upload_type'] === 'multiple' && !pat_doc_ids.includes(body['id'])) &&
                                                                <Upload disabled={true} action={null} fileList={fileList} onChange={this.handleChange} onClick={() => { this.setState({ body: body }) }}  >
                                                                    {/* maxCount={body['upload_type'] === 'single' ? 1 : 5} multiple={body['upload_type'] === 'single' ? false : true} */}
                                                                    {/* <Tooltip title="Click here to upload"> */}
                                                                    <Button icon={<CloudUploadOutlined />} disabled={true}></Button>
                                                                    {/* </Tooltip> */}
                                                                </Upload>
                                                            }
                                                            {/* single files reupload */}
                                                            {(body['upload_type'] === 'single') &&
                                                                <React.Fragment>
                                                                    {patientDocument.map((item, key1) => {
                                                                        if ((body['id'] == item['document_id'])) {
                                                                            if (item['files'].length > 0 && item['is_uploaded'] == 1) {
                                                                                return (
                                                                                    <Upload action={null} fileList={fileList} onChange={this.handle2Change} onClick={() => { this.setState({ body: body, file_uploading_id: item['file_uploading_id'] }) }}  >
                                                                                        <Tooltip title="Click here to Re-upload">
                                                                                            {/* <Button icon={<CloudUploadOutlined />} ></Button> */}
                                                                                            <img src={homepage+"/assets/images/icons/edit.png"} alt="Edit" className="pr-1" />
                                                                                        </Tooltip>
                                                                                    </Upload>)
                                                                            } else if (item['files'].length > 0 && item['is_uploaded'] == 0) {
                                                                                return (<React.Fragment>

                                                                                    <Upload action={null} fileList={fileList} onChange={this.handle2Change} onClick={() => { this.setState({ body: body, file_uploading_id: item['file_uploading_id'] }) }}  >
                                                                                        <Tooltip title="Click here to upload">
                                                                                            <Button icon={<CloudUploadOutlined />} ></Button>
                                                                                        </Tooltip>
                                                                                    </Upload>

                                                                                </React.Fragment>)
                                                                            } else {
                                                                                return (<p>-</p>)
                                                                            }
                                                                        }
                                                                    })}
                                                                </React.Fragment>
                                                            }
                                                            {(body['upload_type'] === 'single' && !pat_doc_ids.includes(body['id'])) &&
                                                                <Upload disabled={true} action={null} fileList={fileList} onChange={this.handle2Change} onClick={() => { this.setState({ body: body }) }}  >
                                                                    {/* <Tooltip title="Click here to upload"> */}
                                                                    <Button icon={<CloudUploadOutlined />} disabled={true}></Button>
                                                                    {/* </Tooltip> */}
                                                                </Upload>
                                                            }
                                                        </td>)
                                                    }
                                                }
                                                if (head['key'] === 'submited_files') {
                                                    return (<td>
                                                        {patientDocument.map((item, key) => {
                                                            if (body['id'] == item['document_id']) {
                                                                let files = item['files']
                                                                let filesArray = item['files']
                                                                return (<React.Fragment>
                                                                    {files.map((files, key) => {
                                                                        return (<React.Fragment>
                                                                            {(files['document_url'])
                                                                                ? <div className="row m-0">
                                                                                    <div className="col-8 py-2">
                                                                                        {/* <Tooltip title="Click to View"><a href={`${hostname}${homepage}/counselling/view-document?uid=${umr_no}&ip=${ip_no}&name=${patient_name}&file=${files['document_url'].replaceAll("&", "_ampersand_")}`} target="_blank" className="pr-2">{files['document_url']}</a></Tooltip> */}
                                                                                        <Tooltip title="Click to View"><a href={`${UPLOAD_URL}${umr_no}/${files['document_url'].replaceAll("&", "_ampersand_")}`} target="_blank" className="pr-2">{files['document_url']}</a></Tooltip>
                                                                                    </div>
                                                                                    <div className="col-1 d-inline-flex py-2">
                                                                                        {/* <Tooltip title="View"><a href={`${hostname}/counselling/view-document?uid=${umr_no}&ip=${ip_no}&name=${patient_name}&file=${files['document_url']}`} target="_blank" className="pr-2"><img src="/assets/images/icons/view.png" alt="View" className="pr-1" /></a></Tooltip> */}
                                                                                        {/* <Upload action={null} fileList={fileList} onChange={this.handle2Change} onClick={() => { this.setState({ body: body, file_uploading_id: files['file_uploading_id'] }) }}  >
                    <Tooltip title="Re-upload">
                        <img src="/assets/images/icons/edit.png" alt="Edit" className="pr-1" />
                    </Tooltip>
                </Upload> */}
                                                                                        {ui_form_type === 'view' && disable_15days === true ?
                                                                                            <DeleteOutlined className="text-danger pt-1" style={{ cursor: 'not-allowed' }} />
                                                                                            : <Tooltip title="Delete">
                                                                                                <DeleteOutlined className="text-danger pt-1" onClick={() => { this.deleteConfirm(filesArray); this.setState({ file_uploading_id: files['file_uploading_id'],'filesArray':filesArray }) }} />
                                                                                            </Tooltip>}
                                                                                    </div>
                                                                                    <div className="col-3 py-2">
                                                                                        <Tooltip title="Uploaded Date"><p className="m-0">{files['uploaded_date'] ? (moment(files['uploaded_date']).format('DD-MMM-YY HH:mm')) : '--'}</p></Tooltip>
                                                                                    </div>
                                                                                </div>
                                                                                : null}
                                                                        </React.Fragment>)

                                                                    })}
                                                                </React.Fragment>)
                                                            }
                                                        })}
                                                    </td>)
                                                }
                                                return (<td className="text-capitalize">{(body['document_description'] !== null) ? body['document_description'] : 'NA'}</td>)
                                            })}
                                        </tr>)
                                    })}
                                </tbody>
                            </table>
                            <div className="text-center m-4">
                            <button className="btn btn-next" onClick={() => this.setModal1Visible(false)}> Close</button>
                            </div>
                            {/* {docTypes.map((data, key) => {
                            return (
                                <div className="d-flex flex-column mb-3">
                                    <div className="d-inline-flex w-100">
                                        <span className="mt-1 w-75"> {key + 1}. {data.document_type}</span>
                                        
                                        {(data.status !== true) && <Uploadlayer {...this.props} {...this.state} />}
                                    </div>                                    
                                        {data.status && <span class="badge badge-success my-auto" style={{width: '60px'}}>Verified</span>}
                                        {(data.status == false) && <span class="badge badge-danger my-auto" style={{width: '60px'}}>Rejected</span>}
                                     <span><a href="#" target="_blank">{data.preupload}</a></span>
                                </div>
                            )
                        })} */}
                        </div>
                    </Modal>

                {/* </div>
            </div> */}
        </React.Fragment>)
    }
}
export default Counselling_upload;